import React from 'react'

const MySimpleInput = ({ id, value, onChange, placeholder }) => {
    return (
        <input key={id} className="my-input" value={value} onChange={(e) => onChange(id, e)} placeholder={placeholder} />
    )
}

export default React.memo(MySimpleInput)